document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('ReelUpProductLoaded', function(e) {
    let __product = e.detail.productJSON;
    let __productSelector = e.detail.productSelector;
    let __productDescription = __productSelector.querySelector('.reelUp_product_description');
      
    if (__productDescription) {
      function removeTagsAndUnicode(element) {
        // Remove <b> tags
        let boldTags = element.getElementsByTagName("b");
        for (let j = boldTags.length - 1; j >= 0; j--) {
          boldTags[j].parentNode.removeChild(boldTags[j]);
        }
        
        // Remove <br> tags
        let brTags = element.getElementsByTagName("br");
        for (let k = brTags.length - 1; k >= 0; k--) {
          brTags[k].parentNode.removeChild(brTags[k]);
        }
            
        // Remove Unicode equivalents of <b> and <br>
        let htmlContent = element.innerHTML;
        htmlContent = htmlContent.replace(/&lt;b&gt;/g, '');
        htmlContent = htmlContent.replace(/&lt;\/b&gt;/g, '');
        htmlContent = htmlContent.replace(/&lt;br&gt;/g, '');
        htmlContent = htmlContent.replace(/&lt;br ?\/?&gt;/g, '');
    
        // Remove <span>&lt;</span><span>br</span><span>&gt;&lt;</span><span>br</span><span>&gt;</span>
        htmlContent = htmlContent.replace(/<span>&lt;<\/span><span>br<\/span><span>&gt;&lt;<\/span><span>br<\/span><span>&gt;<\/span>/g, "");
        element.innerHTML = htmlContent;
      }
      removeTagsAndUnicode(__productDescription);
    }
  });
});
